import React, { useState } from 'react';
import DateInput from './DateInput';

const Popup2 = (props) => {

// const []
  

  const popupStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    borderRadius: '5px',
    padding: '25px 34px',
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.2)',
    zIndex: '9999',
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: '9998',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '5px',
    right: '10px',
    cursor: 'pointer',
  };
  
  return (
    <>
      
      
        <div style={overlayStyle} >
          <div className='popup-style' style={popupStyle} >
            <button  style={closeButtonStyle} onClick={props.togglePopup2}>
              X
            </button>
            {((typeof props.title === 'string' || props.title instanceof String) && props.title !== '') && <h2 style={{marginBottom:'20px'}}>{props.title}</h2>}
            {((typeof props.paratext === 'string' || props.paratext instanceof String) && props.paratext !== '') && <p>{props.paratext}</p>}

            <br/>


            {props.datePicker && 

              <DateInput
              recommendedDate={props.recommendedDate}
              submitFunc={props.submitFunc}
              // selectedPrice={selectedPrice}
              // selectedPlanName={selectedPlanName}
              // onDateChange={handleTrialDateChange}
              selectedDateRedux={props.selectedDateRedux}
              selectedDateEnablePropRedux={props.selectedDateEnableProp}
              togglePopup2 ={props.togglePopup2}
              />
            }
          </div>


          
        </div>
     
    </>
  );
};

export default Popup2;